import Swal from 'sweetalert2'

function Notification(config, returnConfig = false) {
  const swalConfig = {
    icon: NOTIFICATION_ICONS[config?.style],
    title: config?.title || NOTIFICATION_TITLE[config?.style] || '',
    html: config?.text
  }

  if (config?.style === NOTIFICATION_STYLES.QUESTION) {
    swalConfig.showCancelButton = true
    swalConfig.confirmButtonText = config?.confirmButtonText || 'YES'
    swalConfig.cancelButtonText = config?.cancelButtonText || 'NO'
  }
  const suppressNotification = JSON.parse(localStorage.getItem('suppressNotification'))
  if (!suppressNotification) {
    return returnConfig ? swalConfig : Swal.fire(swalConfig)
  }
}

let queue = []

function resolveQueue(index = 0) {
  const config = queue[index]
  Notification(config).then(() => {
    if (index + 1 === queue.length) {
      queue = []
    } else {
      resolveQueue(index + 1)
    }
  })
}

function NotificationQueue(config) {
  queue.push(config)
  if (queue.length === 1) {
    resolveQueue()
  }
}

const NOTIFICATION_STYLES = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  INFO: 'INFO',
  QUESTION: 'QUESTION'
}

const NOTIFICATION_ICONS = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  QUESTION: 'question'
}

const NOTIFICATION_TITLE = {
  SUCCESS: 'Success',
  ERROR: 'Error',
  WARNING: 'Warning',
  INFO: 'Info',
  QUESTION: ''
}

export { NOTIFICATION_ICONS, NOTIFICATION_TITLE, Notification, NotificationQueue, NOTIFICATION_STYLES }
